// Application-wide constants
export const CONTACT_EMAIL = 'hello@usenudge.io' as const

export const ANIMATION_DURATION = {
  TICKER: 32,
  FLOAT: 5,
  TESTIMONIAL: 5000,
} as const

export const NAVBAR_HEIGHT = 68
